import { Component, computed, input, model, output, signal } from '@angular/core';
import { AllMetrics } from '@app/core/models/metrics.constants';
import { DelayedHoverDirective } from '@app/shared/directives/delayed-hover.directive';
import { HeapDirective } from '@app/shared/directives/heap.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { IconComponent } from '../icon/icon.component';

type MetricTranslations = Record<AllMetrics, { title: string }>;

@Component({
  selector: 'adspt-metric-menu',
  templateUrl: './metric-menu.component.html',
  styleUrls: ['./metric-menu.component.scss'],
  imports: [IconComponent, NzDropDownModule, DelayedHoverDirective, HeapDirective, TranslatePipe],
})
export class MetricsMenuComponent {
  readonly color = input<string>();
  readonly symbol = input<string>();
  readonly heapName = input<string>();
  readonly disableOption = input<string>();
  readonly placeholder = input<string | null>();
  readonly translations = input<MetricTranslations>();
  readonly disable = model(false);
  readonly showClose = input(false);
  readonly spotlight = model(false);
  readonly showSpotlight = input(false);
  readonly showEmptyState = model(false);
  readonly options = input<string[]>([]);
  readonly isVisible = signal(false);
  readonly marker = computed(() => 'marker-' + this.symbol());

  change = output<string | null>();
  spotlightChange = output<boolean>();
  closed = output<boolean>();

  changeMetric(d) {
    this.showEmptyState.set(!d);
    this.change.emit(d);
  }
  changeValue(spotlight) {
    this.spotlight.set(spotlight);
    this.spotlightChange.emit(this.spotlight());
  }
}
